import React from 'react';
import { useAuthStore } from '../../store/storeAuth';
import TagInput from '../Test/TagInput';
import MicrosoftFileSelect from './MicrosoftFileSelect';

interface PullMicrosoftPowerPointDataProps {
  formData: any;
  onChange: (e: { target: { name: string; value: any } }) => void;
  onChangeSelect: (e: { target: { name: string; value: any } }) => void;
  data: any;
  nodeId: string;
  nodeLabel: string;
}

const PullMicrosoftPowerPointData: React.FC<PullMicrosoftPowerPointDataProps> = ({
  formData,
  onChange,
  onChangeSelect,
  data,
  nodeId,
  nodeLabel,
}) => {
  const { user } = useAuthStore(state => state);

  return (
    <MicrosoftFileSelect
      fileType="pptx"
      fileIdField="microsoftPowerPointFileId"
      label="presentations"
      selectLabel="Search or select a PowerPoint file"
      onChangeSelect={onChangeSelect}
      data={data}
    >
      <TagInput
        placeholder="Select slides [1, 2-5, 8]"
        onChange={onChange}
        name="slidesFilter"
        value={formData.slidesFilter ?? ''}
        isAdvanced
        showCopy
        dataConnected={data?.slidesFilterData || []}
        removeIcons
        labelName="Select Slides (Optional)"
        isCollapsed
        nodeId={nodeId}
        handleId="slidesFilter"
        nodeLabel={nodeLabel}
        labelStyle={{
          fontSize: '14px',
          color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
          fontWeight: 400,
        }}
        advancedCollapsed
      />
    </MicrosoftFileSelect>
  );
};

export default PullMicrosoftPowerPointData;
